import './styles.css';
const DotsElasticLoading = () => {
  return <div className="dot-bricks" />;
};

export default DotsElasticLoading;
